'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VehicleMatchController = function () {
    function VehicleMatchController(authService, userService, loadingService, $scope) {
        "ngInject";

        (0, _classCallCheck3.default)(this, VehicleMatchController);
        this.authService = authService;
        this.userService = userService;
        this.loadingService = loadingService;

        this.vehicleContactSalesMatches = [];
        this.selectedVehicle = null;

        this.params = {};

        $scope.$on('dashboard:viewVehicleMatches', this.viewVehicleMatches.bind(this));

        this.stats = {
            contactToVehicleCount: 0,
            vehicleToContactCount: 0
        };
    }

    (0, _createClass3.default)(VehicleMatchController, [{
        key: 'viewVehicleMatches',
        value: function viewVehicleMatches(evt, params) {
            var ctrl = this;

            ctrl.params = params || ctrl.params;

            ctrl.loadingService.showLoading('vehicleList', 'Loading Matches');

            ctrl.selectedVehicle = null;

            ctrl.userService.salesMatches(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), ctrl.params.userId).then(function (response) {
                ctrl.vehicleContactSalesMatches = response.data.vehicleContactSalesMatches;
                if (ctrl.vehicleContactSalesMatches.length) {
                    ctrl.selectedVehicle = ctrl.vehicleContactSalesMatches[0];
                }

                ctrl.onLoad({ count: ctrl.vehicleContactSalesMatches.length });
            }).finally(function () {
                ctrl.loadingService.hideLoading('vehicleList');
            });
        }
    }]);
    return VehicleMatchController;
}();

exports.default = VehicleMatchController;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/vehicleMatch/vehicleMatch.controller.js